/* coupon block */
if (document.querySelector("coupon-code")) {
  const copyButton = document.querySelector(
    ".coupon-code__wrapper .coupon-code__button"
  );
  const couponCode = document.querySelector(
    ".coupon-code__wrapper .coupon-code__code"
  );
  const successMessage = document.querySelector(
    ".coupon-code__wrapper .coupon-code__success-message"
  );

  copyButton.addEventListener("click", function () {
    navigator.clipboard.writeText(couponCode.innerText).then(
      () => {
        successMessage.classList.add("active");
        setTimeout(() => {
          successMessage.classList.remove("active");
        }, 2000);
      },
      (error) => console.log("error copying coupon code")
    );
  });
}
